import instanciaAxios from './InterceptorAxios';

const servicioEmisor = {
	guardar(emisor) {
		return instanciaAxios.post('/emisor/guardar.json',emisor);
  },
  actualizarCertificados(emisor){
    return instanciaAxios.post('/emisor/actualizarCertificados.json',emisor);
  },

  actualizarLogo(emisor){
    return instanciaAxios.post('/emisor/actualizarLogo.json',emisor);
  },
  actualizarInformacion(emisor){
    return instanciaAxios.post('/emisor/actualizarInformacion.json',emisor);
  },
  buscarEmisor(emisor){
    return instanciaAxios.post('/emisor/buscarEmisor.json',emisor);
  },
  buscarEmisores(){
    return instanciaAxios.post('/emisor/listaEmisores.json');
  }
}

export default servicioEmisor;